/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FieldMappingPreviewVO { 
    internalFieldCode?: string;
    internalFieldLabel?: string;
    magentoAttributeCode?: string;
    magentoAttributeLabel?: string;
    dataType?: FieldMappingPreviewVO.DataTypeEnum;
    value?: any | null;
}
export namespace FieldMappingPreviewVO {
    export const DataTypeEnum = {
        String: 'STRING',
        Decimal: 'DECIMAL',
        Boolean: 'BOOLEAN',
        Integer: 'INTEGER',
        Datetime: 'DATETIME'
    } as const;
    export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];
}


